import PrivilegeToggle from "./PrivilegeToggle";
import { PrivilegeFunctionGroup as PrivilegeFunctionGroupType } from "../types/privilege-types";

interface Props {
  group: PrivilegeFunctionGroupType;
  selectedIds: number[];
  onToggle: (id: number, value: boolean) => void;
}

export default function PrivilegeFunctionGroup({ group, selectedIds, onToggle }: Props) {
  return (
    <div className="border rounded-xl p-4 mb-4 bg-white shadow-sm">
      <h3 className="text-base font-semibold mb-3">{group.function_name}</h3>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {group.privileges.map((p) => (
          <PrivilegeToggle
            key={p.id}
            label={p.name}
            checked={selectedIds.includes(p.id)}
            onChange={(v) => onToggle(p.id, v)}
          />
        ))}
      </div>
    </div>
  );
}
